import { useTriviaContext } from "../context-trivia";

export function TriviaProgress() {
  const { config, machine, playthrough } = useTriviaContext();

  if (!config.progress.visible || machine.phase === "welcome") {
    return null;
  }

  const label =
    machine.phase === "result"
      ? config.results.completeLabel
      : `Question ${machine.questionIndex + 1} of ${playthrough.questions.length}`;

  return (
    <div className="flex w-full flex-none items-center justify-center">
      <div
        className="px-[calc(var(--trivia-space)*2)] py-[var(--trivia-space)] font-bold"
        style={{
          backgroundColor: config.theme.panelColor,
          color: config.theme.buttonText,
          fontSize: "var(--trivia-text-body)",
          borderRadius: "var(--trivia-radius)",
        }}
      >
        {label}
      </div>
    </div>
  );
}
